import { homeTopicIconForSlug } from '../homeTopicTileIcons';

/** `phone-call` or `ti-phone-call` → `ti-phone-call` */
export function normalizeTablerIconClass(iconKey?: string | null): string | undefined {
  const raw = iconKey?.trim();
  if (!raw) return undefined;
  const name = raw.replace(/^ti-/i, '');
  return name ? `ti-${name}` : undefined;
}

export function resolveHomeItemTileIcon(
  iconKey?: string | null,
  slug?: string,
  categoryId?: string,
): string {
  return normalizeTablerIconClass(iconKey) ?? homeTopicIconForSlug(slug ?? '', categoryId);
}
